import React from 'react';

import PropTypes from 'prop-types';
import Select, { createFilter } from 'react-select';
import { FixedSizeList as List } from 'react-window';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

const height = 35;

const MenuList = props => {
  const { options, children, maxHeight, getValue } = props;
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * height;
  return (
    <List
      height={maxHeight}
      itemCount={children.length}
      itemSize={height}
      initialScrollOffset={initialOffset}
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};

MenuList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  children: PropTypes.node.isRequired,
  maxHeight: PropTypes.number.isRequired,
  getValue: PropTypes.func.isRequired
};

const MultiSelect = ({ label, options, updateFilters, value }) => {
  const {
    ORDERS: { selectLabel }
  } = useLocalizedStringsContext();
  const styles = {
    option: provided => ({
      ...provided,
      borderBottom: '1px solid #e3e3e3',
      fontWeight: 100,
      color: '#222',
      backgroundColor: 'white'
    }),
    control: () => ({
      display: 'flex',
      borderRadius: '3px',
      border: '1px solid #333'
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.color,
      fontSize: state.selectProps.myFontSize
    })
  };

  return (
    <div className="dropdown-main-container">
      <h4>{label}</h4>
      <div className="dropdown-container">
        <Select
          placeholder={`${selectLabel}...`}
          value={value}
          styles={styles}
          components={{ MenuList }}
          options={options}
          isMulti
          filterOption={createFilter({ ignoreAccents: false })}
          onChange={selectedValue => {
            updateFilters(selectedValue);
          }}
        />
      </div>
    </div>
  );
};

MultiSelect.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateFilters: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default MultiSelect;
